import React from 'react';
import {observer} from "mobx-react-lite";
import {BottomNavigationBarComponent} from "../../bottom-navigation-bar/bottom-navigation-bar.component";
import {VideoSlidesArenaBox} from "./boxes/video-slides-arena.box";
import {VideoSlidesContentArena} from "./video-slides-arena-content/video-slides-arena-content.component";
import {VideoSlidesHeaderArena} from "./video-slides-arena-header/video-slides-arena-header.component";
import {
    VideoSlidesArenaConfiguration
} from "../../../services/configurations/config-data-sections/arenas.configuration";


export interface VideoSlidesArenaComponentProps {
    configs: VideoSlidesArenaConfiguration;
}

export const VideoSlidesArena: React.FC<VideoSlidesArenaComponentProps> = observer((props) => {

    return (
        <VideoSlidesArenaBox>
            <VideoSlidesHeaderArena filters={props.configs.filters}/>
            <VideoSlidesContentArena />
            <BottomNavigationBarComponent isInVideoSlidesArena={true} />
        </VideoSlidesArenaBox>
    );
})